module.exports = __webpack_public_path__ + "static/img/json-file.e1ee4f81.png";